import Type from 'src/Type';
import config from 'src/utils/config';

import ValueNode from '../ValueNode';

import type Context from 'src/Context';
import type { BaseExpression, Expression, MongoId } from '../../types';

export interface FormulaResourceNodeT extends BaseExpression {
    $type: 'FormulaResourceNode';
    id: MongoId;
}

export default class FormulaResourceNode extends ValueNode<FormulaResourceNodeT> {
    static TYPE = Type.Object({
        key: 'id',
        type: 'StringNode',
        suggestions: 'external:FormulaResource',
        forceSuggestion: true,
    });

    static uiConfig = {
        ...config.presets.default,
        style: {
            background: '#48AFF0',
            color: 'white',
        },
        description: 'Outputs the value of a formula resource defined in the admin UI',
    };

    static getDefault(): Expression {
        return {
            ...super.getDefault(),
            id: this.getDefaultFor('StringNode'),
        };
    }

    async execute(context: Context): Promise<any> {
        const id = await await context.evaluate(this.expression.id);
        if (!id) return null;
        const data = await context.transformation.options.fetchResource(id, true);

        if (!data) throw new Error(`Formula Resource not found "${id}"`);
        return data;
    }
}
